import React from 'react';
import { useTypedTranslation } from '@app/hooks';
import { onPressEnterModal, genericErrorToast } from '@app/helpers';
import { ButtonSubmit } from '@app/components';
import { useDispatch } from 'react-redux';
import { signOut } from '@app/store/actions';
import { onboardService } from '@app/services';
import { AxiosError } from 'axios';
import Icon from '@app/components/Icon/index';

const OnboardLoginAgainComponent = () => {
    const { translation } = useTypedTranslation();
    const dispatch = useDispatch();

    const returnToLogin = () => {
        // clears the onboarding state for the user
        onboardService.getFullToken(handleError, handleNewToken);
    };

    const handleNewToken = () => {
        dispatch(signOut(false));
    };

    const handleError = (error: AxiosError<any>) => {
        // There's nothing we can do if this errors - just toast and return to log in.
        genericErrorToast(error);
        handleNewToken();
    };

    return (
      <div className='onboard--content' onKeyPress={onPressEnterModal(returnToLogin)}>
          <Icon icon='verification2FaSuccessIco' className='onboard__summary-icon' />
          <h1>{translation('ONBOARD_LOGIN_AGAIN_HEADER')}</h1>
          <p className='onboard__description onboard__description-center'>{translation('ONBOARD_LOGIN_AGAIN_BODY')}</p>
          <div className='onboard__buttons'>
              <ButtonSubmit
                buttonText={translation('ONBOARD_LOGIN_AGAIN_BUTTON')}
                className='onboard__button--submit'
                onClick={returnToLogin}
                id='summaryButton'
                isDisabled={false}
                isLoad={false}
              />
          </div>
      </div>
    );
};

export default OnboardLoginAgainComponent;
